module.exports = __webpack_public_path__ + "static/media/AbiodunAndero.b6ed8ff7.png";